var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatRadarLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.0619 20.5311C75.144 14.7028 67.6041 10.7336 59.3958 9.1256C51.1874 7.51756 42.6792 8.34286 34.9471 11.4971C27.215 14.6514 20.6063 19.993 15.9566 26.8464C11.3069 33.6998 8.8252 41.7573 8.8252 49.9998C8.82519 58.2423 11.3069 66.2998 15.9566 73.1532C20.6063 80.0066 27.215 85.3482 34.9471 88.5025C42.6792 91.6567 51.1874 92.4821 59.3957 90.874C67.6041 89.266 75.144 85.2968 81.0619 79.4685L51.1405 49.9998",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9485 32.3187C66.3067 28.8217 61.6668 26.4402 56.6155 25.4754C51.5642 24.5105 46.3284 25.0057 41.5701 26.8983C36.8119 28.7909 32.745 31.9958 29.8837 36.1079C27.0223 40.2199 25.4951 45.0544 25.4951 49.9999C25.4951 54.9454 27.0223 59.7799 29.8837 63.8919C32.745 68.004 36.8119 71.2089 41.5701 73.1015C46.3284 74.994 51.5642 75.4892 56.6155 74.5244C61.6668 73.5596 65.1834 71.8222 68.8252 68.3252L51.5353 49.9999",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.335,
    cy: 8.335,
    r: 8.335,
    transform: "matrix(1 0 0 -1 42.165 58.335)",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatRadarLarge);
export default __webpack_public_path__ + "static/media/chat-radar-large.e0cdfa8a.svg";
export { ForwardRef as ReactComponent };